<div class="me-appointment">
    <div class="container">
        <div class="me-appointment--back_btn">
            <a class="btn btn-link btn-icon btn-icon--left btn-back btn--secondary " [routerLink]="['/me/dashboard']">
                {{ 'back' | translate }}
            </a>
        </div>
        <div class="me-appointment--header">
            <div class="me-appointment--header--title">
                {{ 'Suggested therapists' | translate }}
            </div>
            <div class="me-appointment--header--filter">
                <select class="me-custom-select--select" [(ngModel)]="language">
                    <option class="me-custom-select--option" *ngFor="let lang of languages" [ngValue]="lang.id">
                        {{ lang.name | translate }}
                    </option>
                </select>
                <i class="me-custom-select--dropdown fas fa-chevron-down"></i>
            </div>
        </div>
        
        <div class="me-appointment--therapist">
            <div class="row card-flex">
                <ng-container *ngFor="let therapist of therapists">
                    <div class="col-lg-4 col-xs-12" [class.hidden]="language != 0 && therapist['languages'].indexOf(language) == -1">
                        <div tabindex="0" class="me-appointment--therapist--block">
                            <div class="me-appointment--therapist--block--icon">
                                <div class="me-appointment--therapist--block--icon--wrapper">
                                    <img src="{{therapist['image']['filename']}}">
                                </div>
                            </div>
                            <div class="me-appointment--therapist--block--body">
                                <div class="me-appointment--therapist--block--body--header">
                                    {{therapist['displayName']}}
                                </div>
                                <div class="me-appointment--therapist--block--body--title">
                                    {{therapist['title']}}
                                </div>
                                <div class="me-appointment--therapist--block--body--language">
                                    <ng-container *ngFor="let therapistLang of languages">
                                        <div class="me-appointment--therapist--block--body--language--block" [class.active]="therapistLang['id'] == language" *ngIf="therapist['languages'].indexOf(therapistLang['id']) >= 0">
                                            {{therapistLang['name'] | translate}}
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="me-appointment--therapist--block--body--text" [innerHTML]="therapist.text | storyblokRichtext"></div>
                                <div class="me-appointment--therapist--block--btn">
                                    <button class="btn btn--primary w-100" (click)="viewCalendar(therapist['id'])">
                                        {{ 'View Calendar' | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>